import { render } from "./structuredDeposits3.vue?vue&type=template&id=1e4ce3ba&scoped=true"
import script from "./structuredDeposits3.vue?vue&type=script&lang=js"
export * from "./structuredDeposits3.vue?vue&type=script&lang=js"

import "./structuredDeposits3.vue?vue&type=style&index=0&id=1e4ce3ba&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4ce3ba"]])

export default __exports__